import { useState, useContext } from "react";
import { getDados, getComponentMap } from "../../General/Format/servicos";
import { ClientContext } from "../../../contexts/clientProvider";
import { UserContext } from "../../../contexts/userProvider";
import BaseInput from '../../General/FormsComp/Input/BaseInput';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const Cadastro = () => {
  const { createServico } = useContext(ClientContext);
  const { user, setAlert } = useContext(UserContext);
  const [servico, setServico] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setServico({ ...servico, [name]: value });
  };

  const dados = getDados(servico);
  const componentMap = getComponentMap(handleInputChange);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validação do nome
    if (!servico.nome || servico.nome.trim() === '') {
      setAlert({
        type: 'warning',
        placeholder: 'Nome do serviço é obrigatório',
        visible: true,
        confirm: false,
        title: 'Atenção!'
      });
      return;
    }

    let newService = { ...servico };
    newService.created_at = newService.updated_at = new Date()
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");
    newService.id_usuario = user.id;
    newService.usuario = user.nome;
    
    try {
      const response = await createServico(newService);
      if (response) {
        // Limpar formulário após sucesso
        setServico({});
        setAlert({
          type: 'success',
          placeholder: 'Serviço cadastrado com sucesso!',
          visible: true,
          confirm: false,
          title: 'Sucesso!'
        });
      }
    } catch (err) {
      console.log(err);
      setAlert({
        type: 'error',
        placeholder: 'Erro ao cadastrar serviço',
        visible: true,
        confirm: false,
        title: 'Erro!'
      });
    }
  };

  return (
    <div className="servico-form">
      {dados.map((dado, index) => (
        <div className="servico-form-item" key={index}>
          {componentMap["Geral"](dado)}
        </div>
      ))}
      <BaseButton 
        onClick={handleSubmit} 
        variant="primary" 
        size="lg"
        fullWidth
      >
        Salvar
      </BaseButton>
    </div>
  );
};

export default Cadastro;
